import { component$ } from "@builder.io/qwik";

export interface FaqItem {
  question: string;
  answer: string;
}

export interface FaqListProps {
  items: FaqItem[];
  class?: string;
}

export const FaqList = component$<FaqListProps>(
  ({ items, class: className }) => {
    if (!items?.length) return null;
    return (
      <section
        class={"mt-12 " + (className ?? "")}
        aria-labelledby="faq-heading"
      >
        <h2
          id="faq-heading"
          class="font-heading text-primary mb-6 text-2xl font-bold"
        >
          Frequently Asked Questions
        </h2>
        <dl class="space-y-6">
          {items.map((faq, i) => (
            <div
              key={i}
              class="rounded-lg border border-gray-200 bg-gray-50 p-4"
            >
              <dt class="text-brand mb-2 text-lg font-semibold">
                {faq.question}
              </dt>
              <dd class="text-gray-700">{faq.answer}</dd>
            </div>
          ))}
        </dl>
      </section>
    );
  },
);
